<template>
  <span class="counter" aria-live="polite" v-html="value + ' <span class=\'a11y-sr-only\'>' + trad + '</span>'" :class="{ '-reverse' : reverse, '-active': active }"></span>
</template>

<script>
export default {
  name: 'Counter.vue',
  props: ['value', 'reverse', 'trad', 'active']
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

.counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.2rem;
  min-height: 1.2rem;
  color: var(--_zenith-header-background);
  font-size: 0.9rem;
  line-height: 1;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  background-color: var(--_zenith-header-text-link);

  &.-active {
    opacity: 1;
  }

  &.-reverse {
    color: var(--zenith-theme-primary);
    background: var(--zenith-white);
    border-color: var(--zenith-white);
  }
}

</style>
